import { ERRORS } from '@/constants/error';
import { NOTIFICATION_TYPE, WS_EVENT } from '@/constants/notification';
import LocaleMixin from '@/mixins/locale';
import { setUserLocale } from '@/services/user.service';
import { mapActions, mapGetters } from 'vuex';

export default {
    mixins: [LocaleMixin],
    created() {
        this.fetchUser().then(() => {
            this.handleUserLocale(this.user);
        });
        this.$helpers.refreshToken();
    },
    mounted() {
        this.$socket.connect();
        void this.fetchCountry();
        if (this.loggedIn) {
            void this.logSession();
        }
        this.$notification.requestPermission();
    },
    watch: {
        user: {
            handler(value) {
                this.handleUserChange(value);
            },
            immediate: true,
        },
    },
    computed: {
        ...mapGetters('auth', ['user']),
    },
    methods: {
        ...mapActions('guest', ['fetchCountry']),
        ...mapActions('user', ['logSession']),
        ...mapActions('notification', ['readNotification']),
        ...mapActions('auth', ['fetchUser']),
        async onClickNativeNotification(item) {
            const { id, link, isRead } = item;
            if (!isRead) {
                item.isRead = true;
                await this.readNotification(id);
            }
            if (link) {
                window.open(item.link);
            }
        },
        handleUserChange(user) {
            if (user && !this.connectedSocket) {
                const joinRoomData = {
                    type: NOTIFICATION_TYPE,
                    username: user.username,
                    token: this.accessToken,
                };
                if (this.$socket.connected) {
                    this.$socket.emit('join', joinRoomData);
                } else {
                    this.$socket.on(this.onConnectWsEvent, () => {
                        this.$socket.emit('join', joinRoomData);
                    });
                }
                this.connectedSocket = true;
                this.sockets.subscribe(
                    WS_EVENT.NOTIFICATION,
                    this.handleWsNotification
                );
                this.sockets.subscribe(WS_EVENT.BALANCE, this.handleWsBalance);
                this.sockets.subscribe(
                    WS_EVENT.USER_HAS_BEEN_BANNED,
                    this.handleUserBanned
                );
            }
        },
        handleWsNotification(data) {
            const _that = this;
            this.$store.commit('notification/setPayload', data);
            this.$notification.show(
                data.title,
                {
                    body: data.content,
                    silent: false,
                    tag: data.id,
                    icon: '/notification.png',
                },
                {
                    onclick() {
                        _that.onClickNativeNotification(data);
                    },
                }
            );
        },
        handleWsBalance(data) {
            const { balance } = data;
            this.$store.commit('user/setBalance', balance);
        },
        handleUserBanned(data) {
            if (data?.messageCode === ERRORS.USER_HAS_BEEN_BANNED) {
                this.$store.commit('authentication/setPopupBanned', true);
                this.logout(false);
            }
        },
        async handleUserLocale(user) {
            const availableLocaleByWebsite =
                this.$helpers.getAvailableLocaleCodes(user.website.id);
            const currentLocale = this.$i18n.locale;
            const userLocale = user.locale;

            // If current website language is default language => Set website language to user language
            if (currentLocale === this.$i18n.fallbackLocale) {
                this.switchLocale(userLocale);
            } else {
                // If current website language is another language => Set user's language to website language
                // Check website language is supported in user's website => If not => language is default
                const locale = availableLocaleByWebsite.includes(currentLocale)
                    ? currentLocale
                    : this.$i18n.fallbackLocale;
                // Check if user language diff website language (the language set to user is not support in user's website) => Call api to set user's language to website language
                if (locale !== userLocale) {
                    await setUserLocale(currentLocale);
                    await this.fetchUser();
                } else {
                    // Else set website language to default
                    this.switchLocale(locale);
                }
            }
        },
    },
    destroyed() {
        this.$socket.removeAllListeners(this.onConnectWsEvent);
        this.$socket.disconnect();
    },
};
